import React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { useEffect, useState } from "react";
import { lvService } from "../../../../services/LvService";

function renderTableBody(obj, key) {
    if (key === "entity") {
        return (
            <TableRow key={key}>
                <TableCell component="th" scope="row">
                    {key}
                </TableCell>
                <TableCell colSpan={2} align="center">
                    {obj[key].key}
                </TableCell>
            </TableRow>
        );
    } else if (Array.isArray(obj[key])) {
        return (
            <TableRow key={key}>
                <TableCell component="th" scope="row">
                    {key}
                </TableCell>
                {obj[key]?.map((subObj) => {
                    return (
                        <TableCell key={subObj.id} align="center">
                            {subObj.display_name}
                        </TableCell>
                    );
                })}
            </TableRow>
        );
    } else if (typeof obj[key] === "object") {
        return (
            <TableRow key={key}>
                <TableCell component="th" scope="row">
                    {key}
                </TableCell>
                <TableCell colSpan={2} align="center">
                    {obj[key]?.display_name}
                </TableCell>
            </TableRow>
        );
    } else {
        return (
            <TableRow key={key}>
                <TableCell component="th" scope="row">
                    {key}
                </TableCell>
                <TableCell colSpan={2} align="center">
                    {typeof obj[key] === "boolean" ? obj[key].toString() : obj[key]}
                </TableCell>
            </TableRow>
        );
    }
}

function Row(props) {
    const { obj } = props;
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell>
                    <IconButton aria-label="expand row" size="medium" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {obj.id}
                </TableCell>
                <TableCell align="center">{obj.display_name}</TableCell>
                <TableCell align="center">{obj.display_with_secondary}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Table size="medium">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Field</TableCell>
                                        <TableCell colSpan={2} align="center">
                                            Value
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(obj)
                                        .filter((key) => key !== "id")
                                        .map((key) => renderTableBody(obj, key))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function V3List() {
    const [objectList, setObjectList] = useState([]);
    useEffect(() => {
        const fetchObjects = async () => {
            let objects = await lvService.getAssetObjects("v3");
            if (objects?.data.length) {
                setObjectList(objects.data);
            }
        };
        fetchObjects();
    }, []);

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>id</TableCell>
                        <TableCell align="center">display_name</TableCell>
                        <TableCell align="center">display_with_secondary</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {objectList.map((obj) => (
                        <Row key={obj.id} obj={obj} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
